import React, { useState, useEffect } from 'react';
import { Table, Button, Space, DatePicker, Tag, Modal, Card, Row, Col, Input } from 'antd';
import { useSelector } from 'react-redux';
import { DeleteFilled, EditTwoTone, FilterOutlined, PlusCircleFilled, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { showMessage } from '../../Components/Utils/message';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import dayjs from 'dayjs';
import AuthService from '../../Components/auth/AuthService';
import { encodeId } from '../../Components/common/CommonFun';
import { styled } from '@mui/system';
const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;
const Auth = new AuthService()
const InventoryAdjustmentList = () => {
    const { products, roles, type: roleType } = useSelector((state) => state?.AppState?.userCreds);
    const [allAdjustments, setAllAdjustments] = useState([]);
    const firstDayOfMonth = dayjs().startOf('month');
    const lastDayOfMonth = dayjs().endOf('month');
    const [startDate, setStartDate] = useState(firstDayOfMonth);
    const [endDate, setEndDate] = useState(lastDayOfMonth);
    const navigate = useNavigate()
    const layoutDispatch = useLoadingDispatch()
    const canAccess =
        roleType === 0 ||
        roleType === 1 ||
        (roleType === 2 && roles?.some((role) => role.role_id === 4));

    const { RangePicker } = DatePicker
    const [filters, setFilters] = React.useState({
        dateRange: [dayjs().startOf("month"), dayjs().endOf("month")],
        batchCode: '',
    });

    const handleEdit = (record) => {
        const hasedID = encodeId(record?.id)
        navigate(`/transaction-inventory/${hasedID}`)
    };

    const handleDelete = async (id) => {
        showLoading(layoutDispatch);
        try {
            const res = await Auth.fetch(`/stock/inventory-adjustment`, {
                method: "DELETE",
                body: JSON.stringify({ id: id })

            });
            if (res?.ack) {
                showMessage('success', res?.message);
                getInventoryAdjustments();
            } else {
                showMessage('error', res?.message);
                hideLoading(layoutDispatch);
            }
        } catch (err) {
            console.log(err);
            showMessage('error', err?.message);
            hideLoading(layoutDispatch);
        }
        // finally {
        //   hideLoading(layoutDispatch);
        // }
    };

    const getInventoryAdjustments = async () => {
        showLoading(layoutDispatch);
        const dataToSend = {
            //   limit: limit,
            //   page: page,
        }
        if (filters?.dateRange && filters?.dateRange[0] && filters?.dateRange[1]) {
            dataToSend.start_date = dayjs(filters?.dateRange[0]).format("YYYY-MM-DD");
            dataToSend.end_date = dayjs(filters?.dateRange[1]).format("YYYY-MM-DD");
        }
        try {
            const res = await Auth.post(`/stock/inventory-adjustments`, dataToSend);
            if (res?.ack) {
                const data = res?.inventory_adjustments

                setAllAdjustments(data);
            } else {
                setAllAdjustments([]);
                showMessage('error', res?.message);
            }

        } catch (err) {
            console.log(err);
            showMessage('error', 'Something went wrong while fetching ');
            setAllAdjustments([]);

        }
        finally {
            hideLoading(layoutDispatch);
        }
    }

    useEffect(() => {
        getInventoryAdjustments();
    }, [filters?.dateRange]);

    const columns = [
        {
            title: 'Code',
            dataIndex: 'wms_inventory_adjustment_code',
            key: 'wms_inventory_adjustment_code',
        },
        {
            title: 'Adjustment Type',
            render: (record) => {
                const { wms_cycle_count_code, route_status_id, delivery_date } = record;

                let adjustmentType = 'Inventory';
                if (wms_cycle_count_code) adjustmentType = 'Cycle Count';
                else if (route_status_id) adjustmentType = 'Missed Picking';
                else if (delivery_date) adjustmentType = 'Delivery';

                return <span>{adjustmentType}</span>;
            },
            },
        {
            title: 'Posting Date',
            render: (record) => {
                return (
                    <span>{record?.posting_date ? dayjs(record?.posting_date).format('DD-MM-YYYY') : ''}</span>
                );
            }
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
        },
        {
            title: 'Status',
            render: (record) => {
                const posted = record?.posted_by > 0 ? true : false;
                return (
                    <Tag color={posted ? "green" : 'red'}>{posted ? 'Posted' : 'Pending'}</Tag>
                );
            }
        },
        {
            title: 'Actions',
            width: '100px',
            align: 'center',
            render: (record) => {
                const { wms_cycle_count_code, route_status_id, delivery_date } = record;
                const isInventory =
                !wms_cycle_count_code && !route_status_id && !delivery_date;
                return (
                    <Space>
                    {/* <Button type="link" onClick={() => handleView(record)}>View</Button> */}
                    <EditTwoTone
                        style={{
                            fontSize: "25px",
                            cursor: "pointer",
                        }}
                        onClick={() => handleEdit(record)} />
                    {
                        !record?.posted_by > 0 && (
                            <>
                            {
                                isInventory && (
                                    <DeleteFilled
                                style={{
                                    fontSize: "25px",
                                    cursor: "pointer",
                                    color: "#cd1437",
                                }}
                                onClick={() => {
                                    Modal.confirm({
                                        title: 'Delete Adjustment',
                                        centered: true,
                                        content: `Are you sure to delete this adjustment?`,
                                        onOk: () => handleDelete(record.id),
                                        okText: 'Delete',
                                        cancelText: 'Cancel',
                                        width: 600,
                                        okButtonProps: { size: "large" },
                                        cancelButtonProps: { size: "large" },
                                    });
                                }}
                            />
                                )
                            }
                            </>
                            
                        )
                    }

                </Space>
                )
            }
                
        },
    ];

    return (
        <DataSheet>
            
            <Card title={<><FilterOutlined style={{ color: '#6cb8ff'}} /> Inventory Adjustments</>}
                style={{ marginBottom: '10px' }}
                extra={
                <>
                    {canAccess && <PlusCircleFilled style={{ fontSize: "30px", color: "#1677FF", }} onClick={() => navigate("/transaction-inventory/new")} />}
                </>
                }
            >
                <Row gutter={[6, 1]}>
                    <Col xs={24} md={12} lg={8}>
                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Date Range</label>
                        <RangePicker
                            style={{ width: '100%' }}
                            value={filters.dateRange}
                            onChange={(dates) => setFilters(prev => ({ ...prev, dateRange: dates }))}
                            format="DD-MM-YYYY"
                            allowClear={false}
                        />
                    </Col>
                    <Col xs={24} md={12} lg={6}>
                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Search</label>
                        <Input
                            placeholder="Search"
                            value={filters.batchCode}
                            onChange={(e) => setFilters(prev => ({ ...prev, batchCode: e.target.value }))}
                        />
                    </Col>
                    <Col xs={24} md={12} lg={6}>
                        <Space style={{ width: '100%', marginTop: '25px' }}>
                            <Button
                                type="primary"
                                icon={<SearchOutlined />}
                            >
                                Search
                            </Button>
                        </Space>
                    </Col>

                </Row>
            </Card>
            <Table
                dataSource={allAdjustments}
                columns={columns}
                pagination={false}
                rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
                scroll={{ x: 'max-content' }}
            />
        </DataSheet>
    );
};

export default InventoryAdjustmentList;